import { createReducer, on } from '@ngrx/store';
import { SunbedForm, SunbedState, Zone } from '@shared-models';
import {
  addSunbedToCartAction,
  emptyShoppingCartAction,
  paymentFinishedAction,
  removeSunbedFromCartAction,
  saveBookingIdAction,
  savePaymentInvoiceTypeAction,
  savePaymentMethodAction,
  setEnabledReservationsAction,
  showSunbedCartAction,
  sunbedPrereservationAction,
  sunbedToBeDisabledAction,
} from '@store-sunbed-actions';

export const initialSunbedState: SunbedState = {
  formData: {} as SunbedForm,
  zone: {} as Zone,
  zoneIndex: -1,
  cartItems: [],
  displayCart: false,
  bookingId: '',
  payment: {
    invoiceType: '',
    method: '',
    noPayment: false,
    cardType: '',
    paymentCompleted: false,
  },
  selection: [],
  reservationsEnabled: true,
  lastCartId: '',
};

export const sunbedReducer = createReducer(
  initialSunbedState,
  on(sunbedPrereservationAction, (state, action) => ({
    ...state,
    formData: action.formData,
    zone: action.zone,
    zoneIndex: action.zoneIndex,
  })),

  on(addSunbedToCartAction, (state, action) => ({
    ...state,
    cartItems: [...state.cartItems, action.sunbed],
    lastCartId: state.lastCartId === '' ? (action.sunbed.cartId ?? '') : state.lastCartId,
  })),

  on(removeSunbedFromCartAction, (state, action) => {
    const items = [...state.cartItems];
    const toBeRemoved = items.find(item => item.id === action.sunbed.id);
    if (toBeRemoved) {
      items.splice(items.indexOf(toBeRemoved), 1);
    }
    return {
      ...state,
      cartItems: [...items],
    };
  }),

  on(showSunbedCartAction, (state, action) => ({
    ...state,
    displayCart: action.display,
  })),

  on(saveBookingIdAction, (state, action) => ({
    ...state,
    bookingId: action.bookingId,
  })),

  on(savePaymentMethodAction, (state, action) => ({
    ...state,
    payment: {
      ...state.payment,
      method: action.method,
      cardType: action.cardType,
    },
  })),

  on(paymentFinishedAction, state => ({
    ...state,
    payment: {
      ...state.payment,
      paymentCompleted: true,
    },
  })),

  on(savePaymentInvoiceTypeAction, (state, action) => ({
    ...state,
    payment: {
      ...state.payment,
      invoiceType: action.invoiceType,
    },
  })),

  on(sunbedToBeDisabledAction, (state, action) => ({
    ...state,
    selection: action.sunbeds,
  })),

  on(setEnabledReservationsAction, (state, action) => ({
    ...state,
    reservationsEnabled: action.enabled,
  })),

  on(emptyShoppingCartAction, state => ({
    ...initialSunbedState,
  })),
);
